import Page404 from "../views/Page404.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import LandingLayout from "../views/LandingLayout.vue";
import { CONTEXT } from "@/constants";
import { firebase } from "@/firebase";

const RESERVED_PATHS = ["/page-not-found"];

Vue.use(VueRouter);

const routes = [
  {
    path: "/i/:id",
    component: LandingLayout,
    props: (route) => ({
      bot_id_params: route.params.id,
      variables: route.query,
      context: CONTEXT.PRODUCTION,
    }),
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("context", CONTEXT.PRODUCTION);
      next();
    },
  },

  {
    path: "/preview/:id/:token",
    component: LandingLayout,
    props: (route) => ({
      bot_id_params: route.params.id,
      variables: route.query,
      simulator_mode: true,
      channel: "landing",
      context: CONTEXT.SANDBOX,
      token: route.params.token,
    }),
    beforeEnter: async (to, from, next) => {
      try {
        await firebase.auth().signInWithCustomToken(to.params.token);
        localStorage.setItem("context", CONTEXT.SANDBOX);
        next();
      } catch {
        next("/page-not-found");
      }
    },
  },
  {
    path: "/preview-without-chat/:id/:token",
    component: LandingLayout,
    props: (route) => ({
      bot_id_params: route.params.id,
      variables: route.query,
      simulator_mode: true,
      enabled_chat: false,
      context: CONTEXT.SANDBOX,
      token: route.params.token,
    }),
    beforeEnter: async (to, from, next) => {
      try {
        await firebase.auth().signInWithCustomToken(to.params.token);
        localStorage.setItem("context", CONTEXT.SANDBOX);
        next();
      } catch {
        next("/page-not-found");
      }
    },
  },
  {
    path: "/page-not-found",
    component: Page404,
  },
  {
    path: "/:bot",
    component: LandingLayout,
    props: (route) => ({
      custom_link: route.params.bot,
      variables: route.query,
      context: CONTEXT.PRODUCTION,
    }),
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("context", CONTEXT.PRODUCTION);
      next();
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (RESERVED_PATHS.includes(to.path)) {
    next();
  } else if (to.params.id !== undefined) {
    setTimeout(() => {
      next();
    }, 100);
  } else if (to.params.bot !== undefined) {
    setTimeout(() => {
      next();
    }, 100);
  } else {
    next();
  }
});

export default router;
